import * as Sentry from '@sentry/react';
import { ENVIRONMENT, SENTRY_DSN } from '@web/config';
import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
if (SENTRY_DSN) {
    Sentry.init({
        dsn: SENTRY_DSN,
        integrations: [
            Sentry.reactRouterV6BrowserTracingIntegration({
                useEffect: useEffect,
                useLocation: useLocation,
                useNavigationType: useNavigationType,
                createRoutesFromChildren: createRoutesFromChildren,
                matchRoutes: matchRoutes
            }),
            Sentry.replayIntegration()
        ],
        environment: ENVIRONMENT
    });
}
